import Icon from '../components/Icon.vue'

Icon.register({"toggle-right":{"width":1536,"height":1792,"paths":[{"d":"M1088 896q0 33-27 52l-448 320q-31 23-66 5-35-17-35-57v-640q0-40 35-57 35-18 66 5l448 320q27 19 27 52zM1280 1376v-960q0-14-9-23t-23-9h-960q-14 0-23 9t-9 23v960q0 14 9 23t23 9h960q14 0 23-9t9-23zM1536 416v960q0 119-84.5 203.5t-203.5 84.5h-960q-119 0-203.5-84.5t-84.5-203.5v-960q0-119 84.5-203.5t203.5-84.5h960q119 0 203.5 84.5t84.5 203.5z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/toggle-right.js
// module id = 3X4w
// module chunks = 0